var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "v-image-wrapper"
  }, [_c('img', {
    ref: "realImage",
    staticClass: "real-image",
    style: _vm.imgStyle,
    attrs: {
      "alt": _vm.alt,
      "src": _vm.imgSrc,
      "data-src": _vm._src,
      "lazy": "true"
    },
    on: {
      "error": function error($event) {
        _vm.error = true;
      },
      "load": function load($event) {
        _vm.isLoad = true;
      }
    }
  }), _vm.error ? _c('span', {
    staticClass: "error-wrapper",
    on: {
      "click": function click($event) {
        $event.stopPropagation();
        return _vm.retryLoadImg.apply(null, arguments);
      }
    }
  }, [_c('span', {
    staticClass: "error-msg"
  }, [_vm._v(_vm._s(_vm.errMsg))])]) : _vm._e()]);
};
var staticRenderFns = [];
export { render, staticRenderFns };